var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretSolidLeft = function SvgCaretSolidLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M5.708 10.89a1.565 1.565 0 0 0 0 2.211L16.092 23.54c.61.613 1.597.613 2.2 0a1.57 1.57 0 0 0 0-2.212l-9.28-9.33 9.28-9.329c.61-.613.61-1.605 0-2.211a1.55 1.55 0 0 0-2.2 0L5.708 10.896z"
  })));
};
export default SvgCaretSolidLeft;